import script from "./InputError.vue?vue&type=script&setup=true&lang=js"
export * from "./InputError.vue?vue&type=script&setup=true&lang=js"

export default script